// extracted by mini-css-extract-plugin
export var container = "ImageGallery-module--container--peryg";
export var thumbnailButton = "ImageGallery-module--thumbnail-button--ThVPU";
export var thumbnailImage = "ImageGallery-module--thumbnail-image--VUGDm";